function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.572 6.173L22.4 0l-4.973 4.973.009.008L2.148 20.27 0 28.678l8.31-2.258 15.282-15.283.008.009 4.972-4.972zM7.232 24.56l-.306.084-2.99-2.99.081-.319L18.823 6.528l3.223 3.219L7.232 24.561zM22.4 2.934l3.237 3.239-2.038 2.037-3.238-3.238 2.038-2.038z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "29",
  height: "29"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.572 6.173L22.4 0l-4.973 4.973.009.008L2.148 20.27 0 28.678l8.31-2.258 15.282-15.283.008.009 4.972-4.972zM7.232 24.56l-.306.084-2.99-2.99.081-.319L18.823 6.528l3.223 3.219L7.232 24.561zM22.4 2.934l3.237 3.239-2.038 2.037-3.238-3.238 2.038-2.038z",
  fill: "currentColor"
}))));